// extracted by mini-css-extract-plugin
module.exports = {"supportMessage":"supportMessage___1Ffbo"};